import Vue from 'vue'
import Vuex, { mapGetters } from 'vuex'
import LazyloadVue from 'lazyload-vue'
import store from '../store'
import Client from '../services/client'
import Results from '../components/elementStaff.vue'
import Search from '../components/search.vue'
import Pagination from '../components/staffPagination.vue'
import Category from '../components/category.vue'
import Orderby from '../components/order.vue'

Vue.use(Vuex)
Vue.use(LazyloadVue)

const el = document.querySelector('#staff-directory')
if (el !== null) {
  const vm = new Vue({
    store,
    components: {
      Category,
      Search,
      Orderby,
      Results,
      Pagination
    },
    delimiters: ['[[', ']]'],
    data () {
      return {
        siteId: null,
      }
    },
    methods: {
      updateResults (data) {
        const totalPages = Math.ceil(data.entryCount / this.$store.state.staff.limit)
        const currentPage = this.$store.state.staff.pageInfo.currentPage
        this.$store.commit('staff/UPDATE_PAGEINFO', {
          currentPage: currentPage,
          totalPages: totalPages,
          hasPreviousPage: currentPage > 1,
          hasNextPage: currentPage < totalPages
        })
        this.$store.commit('staff/UPDATE_COUNT', data.entryCount)
        this.$store.commit('staff/UPDATE_RESULTS', data.entries)
      },
      getResults () {
        Client.getStaff(this.variables)
          .then(response => {
            this.updateResults(response.data.data)
          })
          .catch(error => {
            console.log(error)
          })
      },
      getCategories () {
        Client.getStaffCategories()
          .then(response => {
            if (response.data.errors) {
              console.log(response.data.errors)
            } else {
              const data = response.data.data
              this.$store.commit('staff/UPDATE_CATEGORIES', data.categories)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    computed: {
      ...mapGetters('staff', ['variables'])
    },
    watch: {
      variables: function () {
        this.getResults()
      }
    },
     mounted () {
      this.siteId = this.$el.attributes['data-site-id'].value
    },
    created () {
      this.getCategories()
      this.getResults()
    }
  })
  vm.$mount(el)
}
